export default {
  title: "MySchleppApp"
};
